import React, { Suspense } from "react";
import { CircularProgress } from "@mui/material";

export function WithSuspense<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <Suspense
      fallback={
        <div className="loading">
          <CircularProgress
            style={{ color: "#228322" }}
            size="200px"
          ></CircularProgress>
        </div>
      }
    >
      <Child {...props} />
    </Suspense>
  );
}
